import * as React from 'react';
import { connect } from 'react-redux';
import page from 'page';

import { expandDataProps } from 'utils/helper/common';

import type { Dispatch } from 'redux';
import type { SyntheticEvent } from 'react';

const isIncludePath = (urls, to) => (urls || []).some((url) => (new RegExp(url)).test(to));

type OwnProps = {
  target: string,
  to: string,
  title?: string,
  className: string,
  activeClassName: string,
  includes: Array<string>,
  children: React.ReactNode,
  data: any,
  onClick: (event: SyntheticEvent<HTMLElement>) => void,
  dispatch: Dispatch
};

type StateProps = {
  isActive: boolean
};

type Props = OwnProps & StateProps;

class Link extends React.Component<Props> {
  // Only re render if we change activeClass and the location change
  shouldComponentUpdate(nextProps) {
    const { isActive, children, to } = this.props;

    return (
      nextProps.isActive !== isActive ||
      nextProps.children !== children ||
      nextProps.to !== to
    );
  }

  handleClick = (event) => {
    const { onClick, target, to } = this.props;
    const newTab = event.ctrlKey || event.metaKey;

    if (onClick) {
      onClick(event);
    }

    if (
      to &&
      !target &&
      event.button === 0 &&
      !event.defaultPrevented
    ) {
      event.preventDefault();


      if (newTab) {
        window.open(to, '_blank');
      } else {
        page(to);
      }
    }
  };

  render() {
    const {
      to,
      children,
      activeClassName,
      isActive,
      data,
      dispatch, // eslint-disable-line
      // skip adding onClick even since we handle clicks by onMouseDown
      onClick, // eslint-disable-line
      ...props
    } = this.props;

    if (isActive) {
      props.className = `${props.className} ${activeClassName}`;
    }

    return (
      <a
        {...props}
        {...expandDataProps(data)}
        onMouseDown={this.handleClick}
        href={to}
      >
        {children}
      </a>
    );
  }
}

const mapStateToProps = ({ router }, props): StateProps => ({
  isActive: (
    props.activeClassName &&
    router.location &&
    ((router.location.path === props.to) || (props.includes && isIncludePath(props.includes, router.location.path)))
  )
});

export default connect(mapStateToProps)(Link);
